import ButtonLink from "plos/src/components/links/ButtonLink";
import { useTranslation } from "react-i18next";
import ChallengeLogo from "../../../../img/fpl-challenge-logo.svg?react";
import { ControlArrowRight } from "../../../icons/Arrows";
import styles from "./ChallengeTeamSavedContent.module.css";

const ChallengeTeamSavedContent = () => {
  const { t } = useTranslation("pickTeam");
  return (
    <>
      <h3>{t("teamSaved", "Team Saved")}</h3>
      <div className={styles.challengePanelBackground}>
        <div className={styles.challengePanelContent}>
          <ChallengeLogo />
          <p className={styles.challengeCopy}>
            {t(
              "challengeTeamSaved.p1",
              "Play Fantasy Challenge for the chance to win prizes every week. You can still enter this week's challenge after the deadline!",
            )}
          </p>
          <ButtonLink to="https://fplchallenge.premierleague.com/">
            {t(
              "challengeTeamSaved.selectLineupButton",
              "Select your FPL Challenge lineup now!",
            )}
            <div>
              <ControlArrowRight />
            </div>
          </ButtonLink>
        </div>
      </div>
    </>
  );
};

export default ChallengeTeamSavedContent;
